import React from 'react'
import { CCard, CCardBody, CCol } from '@coreui/react'
import { Link } from 'react-router-dom';


const Card = ({ cardIcon, title, routes, count, symbol, state, Id }) => {

  return (
    <CCol sm={6} md={6} xl={4} lg={4} id={Id}>
      <CCard className="hsnc-stat-card">
        <Link style={{ textDecoration: 'none' }} to={{ pathname: routes, state: state }}>
          <CCardBody className="d-flex align-items-center justify-content-between">
            <div>
              <div className="hsnc-stat-label">{title}</div>
              <div className="hsnc-stat-num">{symbol + (isNaN(Number(count)) ? count : Number(count).toLocaleString('en-IN'))}</div>
            </div>
            <div className="hsnc-stat-icon">
              <img src={cardIcon} alt="" />
            </div>
          </CCardBody>
        </Link>
      </CCard>
    </CCol>

  );
}

export default Card;
